import { DuplicateCaseLookupResult } from '../../../application/domain/entities/DuplicateCaseLookupResult';
import { DuplicateCaseLookup } from '../../../application/domain/entities/DuplicateCaseLookup';
import {
  DuplicateCaseLookupResponseDto,
  DuplicateCaseLookupItemDto,
} from '../dto/DuplicateCaseLookupResponseDto';

export function mapDuplicateCaseLookupItemDtoToEntity(
  dto: DuplicateCaseLookupItemDto
): DuplicateCaseLookup {
  return {
    everifyDuplicateCaseLookupId: dto.everifyDuplicateCaseLookupId,
    existingCaseNumber: dto.existingCaseNumber,
    existingCaseStatus: dto.existingCaseStatus,
    everifyCaseId: dto.everifyCaseId,
    existingCaseStatusDisplay: dto.existingCaseStatusDisplay ?? '',
    existingCaseCreatedAt: dto.existingCaseCreatedAt ?? null,
    heldLocally: dto.heldLocally !== false,
  };
}

export function mapDuplicateCaseLookupResponseDtoToEntity(
  dto: DuplicateCaseLookupResponseDto
): DuplicateCaseLookupResult {
  return {
    name: dto.name,
    maskedSsn: dto.maskedSsn,
    duplicateReason: dto.duplicateReason,
    existingDuplicateCases: Array.isArray(dto.existingDuplicateCases)
      ? dto.existingDuplicateCases.map(mapDuplicateCaseLookupItemDtoToEntity)
      : [],
  };
}
